module.exports = __webpack_public_path__ + "components/flag/static/square/iq-5ac78cba94d173dcfe4679d5bfd011c5.svg";